import type { ComponentType } from "react";
import { BriefcaseIcon, HeartIcon } from "@heroicons/react/24/outline";

import Card from "components/Card";
import {
  arrangementListings,
  planningListings,
  type HomeListing,
  type MeHome,
} from "helpers/me-home";

function Section({
  head,
  icon: Icon,
  listings,
}: {
  head: string;
  icon: ComponentType<{ className?: string }>;
  listings: HomeListing[];
}) {
  if (listings.length === 0) return null;
  return (
    <div className="overflow-hidden rounded-xl border border-oat-200 bg-white shadow-sm">
      <h2 className="flex items-center gap-2.5 border-b border-oat-100 px-5 py-4 font-serif text-[21px] font-normal text-soil">
        <Icon className="h-5 w-5 flex-none text-oat-600" aria-hidden="true" />
        {head}
      </h2>
      <div className="flex flex-col divide-y divide-oat-100">
        {listings.map((listing) => (
          <Card
            key={listing.key}
            link={listing.to ?? undefined}
            name={listing.name}
            badgeText={listing.pill}
          />
        ))}
      </div>
    </div>
  );
}

/** A person's home: their arrangements (cases, and the quotes made for
 * them) and their pre-planning, each section left out when empty. */
export default function HomeSections({ home }: { home: MeHome }) {
  return (
    <div className="space-y-4">
      <Section
        head="Arrangements"
        icon={HeartIcon}
        listings={arrangementListings(home)}
      />
      <Section
        head="Pre-planning"
        icon={BriefcaseIcon}
        listings={planningListings(home)}
      />
    </div>
  );
}
